import { useCallback, useEffect, useState } from "react";
import MultiItemSelectDropdown from "../inputs/MultiItemSelectDropdown";
import AppContext from "../context/AppContext";
import DateField from "../inputs/DateField";
import { getSupplierProductsUrl, getTravellers, removeDuplicates } from "../utils";
import SelectDropdown from "../inputs/SelectDropdown";

export default function EasyOTAFormExperience({ onSubmit, supplierId, supplierLoc, supplierSettings, product }) {
   // console.log("supplierLoc", supplierLoc);
   const [submitData, setSubmitData] = useState({
      location: supplierLoc.location,
   });
   const [locations, setLocations] = useState([]);
   const [popupsListeners, setPopupsLisners] = useState([]);
   const [travellers, setTravellers] = useState({});
   const travellersItems = getTravellers(supplierSettings);
   const popupCloseEvent = () => {
      popupsListeners.forEach((handler) => {
         handler();
      });
   };
   const registerPops = useCallback((handler) => {
      setPopupsLisners((prev) => {
         return [...prev, handler];
      });
   }, []);

   const handleOnChange = useCallback(({ name, value }) => {
      setSubmitData((prev) => {
         return {
            ...prev,
            [name]: value,
         };
      });
   }, []);

   const handleSubmit = (ev) => {
      ev.preventDefault();
      console.log("Submit", submitData);
      onSubmit && onSubmit({ ...submitData, travellers });
   };

   useEffect(() => {
      function fetchLocations() {
         if (supplierId) {
            let showActs = supplierSettings.showDestinationActivities;
            console.log({ product });
            if (!product) return [];
            if (!showActs) {
               console.log({ product });
               setLocations(
                  product.searchLocations.map((l) => {
                     let sl = {
                        ...l.searchLocation,
                     };
                     return sl;
                  })
               );
               return;
            }
            let url = getSupplierProductsUrl(supplierId, product.id);
            fetch(url)
               .then((res) => res.json())
               .then((json) => {
                  console.log("Data: ", { json });
                  let resLocations = removeDuplicates(
                     json.map((i) => {
                        return {
                           ...i.productLocations[0].supplierLocation,
                        };
                     }),
                     "id"
                  );
                  setLocations(resLocations);
               });
         }
      }
      fetchLocations();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [supplierId]);

   return (
      <AppContext.Provider value={{ registerPopupListener: registerPops, popupCloseEvent }}>
         <div className='form'>
            <form action='#' method='post' id='search-form' onSubmit={handleSubmit} autoComplete='off'>
               <div className='fields'>
                  <SelectDropdown
                     field='location'
                     label='Location'
                     hint='City or airport'
                     options={locations}
                     onChange={handleOnChange}
                     hideIfSingleOption
                  />
                  <DateField
                     field='departure_date'
                     label='When'
                     minDate={new Date()}
                     required
                     onChange={handleOnChange}
                  />
                  <MultiItemSelectDropdown
                     field='travellers'
                     label='Travellers'
                     items={travellersItems}
                     data={travellers}
                     settings={supplierSettings}
                     onChange={(selected) => {
                        setTravellers((prev) => {
                           return {
                              ...prev,
                              ...selected,
                           };
                        });
                     }}
                     required
                     validity='You must select atleast 1 adult'
                  />
               </div>
               <button className='btn'>Search</button>
            </form>
         </div>
      </AppContext.Provider>
   );
}
